import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { CacheService } from "@delon/cache";
import { OptionService } from "@root/router/index/option.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { some, isNil } from "lodash";
@Component({
  selector: "v4-common-house-list-filter",
  templateUrl: "./house-list-filter.component.html",
  styleUrls: ["./house-list-filter.component.scss"],
})
export class V4CommonHouseListFilterComponent implements OnInit {
  @Input() form: UntypedFormGroup;

  // listOfSubaccountOption = [];
  listOfLabel = [];

  get showResetBtn() {
    return some(this.form.value, (v) => !isNil(v));
  }

  get optionOfGroup() {
    return this.optSrv.optionsOfHouseGroup;
  }

  constructor(private t: TranslateService, private cache: CacheService, private optSrv: OptionService) {}

  ngOnInit() {
    this.initFilterOptions();
  }

  private initFilterOptions() {
    // this.initSubaccountOption();
    this.initLabelOption();
  }

  initLabelOption() {
    this.cache
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 10 })
      .subscribe((rst: any) => {
        this.listOfLabel = rst?.data?.house_tag
          .filter((t) => !t.delete_time)
          .map((t) => ({
            label: t.name,
            value: t.id,
            color: t.color,
          }));
      });
  }

  onFiltersChange(value) {
    this.cache.set("house_list_filter", value);
  }

  onReset() {
    this.form.reset();
    // this.tmpCompatRubbish_group = true;
  }
}
